module.exports = __webpack_public_path__ + "static/media/proj1_img14.adbf8b6f.jpg";